<template>

  <template v-if="inclFB">GraficoUnidadHighChartLive: beg template<br></template>

  <div class="">

    <template v-if="inclFB">
      <span class="text-black text-xs">
        noShowSetpoint: '{{ noShowSetpoint }}',
        this.vista: '{{ this.vista }}',
        granularidad: '{{ granularity }}',
        dias: '{{ dias }}',
        this.frecuencia_minutos: '{{ this.frecuencia_minutos }}'.
        <br>
      </span>
      <span>
        hpia={{ hpia }}.<br>
        hpov={{ hpov }}.
      </span>
    </template>

    <EditHorasModal :nombrejaula="objJaula.descripcion" :datos="datosSetPoint" :open="modalstate"
      @updateRangoHoras="updateRangoHoras" @close="closeModal"></EditHorasModal>

    <div v-if="esModal" class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-2 p-0">

      <!--- graficochart live  -->

    </div>
   
    <!-- GUHCL: BEG Si Vista Normal -->
    <div v-if="!noShowSetpoint">

<template v-if="inclFB">
  <span class="o2">Oxigeno</span>
  <span class="o3">Ozono</span>
</template>

<template v-if="inclFB">
<br>SdO: ctl={{hpia[1].cntrl}} val={{hpia[1].measu}} umb={{ hpia[1].loval }}
<br> OD: ctl={{hpia[2].cntrl}} val={{hpia[2].measu}} umb={{ hpia[2].loval }}
</template>

      <div class="text-xs col-span-2 border-solid border-0 border-indigo-300   text-left">
<template v-if="inclFB">B</template>
        <span v-if="result_mediciones_haydatos"><span class="green custom-shadow"></span></span>
        <span v-if="this.idEstado === 9"><span class="red custom-shadow"></span></span>
        <span v-if="this.idEstado === 1"><span class="green custom-shadow"></span></span>
        <span v-if="this.idEstado === 2"><span class="blue custom-shadow"></span></span>
        <span v-if="this.idEstado === 3"><span class="yellow custom-shadow"></span></span>
        <span v-if="this.idEstado === 4"><span class="orange custom-shadow"></span></span>
        <span v-if="result_mediciones_haydatos == false">
          <!-- <span class="inline-block h-5 w-5 bg-gray-400 rounded-full"></span>  -->
          <span class="red custom-shadow"></span>
        </span>
<template v-if="inclFB">C</template>
        <span class="text-lg  font-bold ml-2 "> {{ objJaula.descripcion }} </span>
<template v-if="inclFB">D</template>
        <span class="text-xs  font-bold ml-4 ">
          <a href="#" class="" @click.prevent="openModalGrafico(objJaula)"> {{ $t('ampliar_grafico') }}</a>
        </span>
<template v-if="inclFB">E</template>
      </div>
<template v-if="inclFB">F</template>

      <!-- -- GUHCL: BEFORE SETPOINTS -- -->
      <template v-if="inclSP">

      <div class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-2 pl-1 pr-1">

        <div v-if="Object.keys(reqO2).length > 0"
          class="text-xs   text-blue-600 border-solid border-0 border-indigo-300 pl-1 pr-1  pt-4 text-center">

        </div>
        <div v-if="Object.keys(maxMgl).length > 0"
          class="text-xs   text-blue-600 border-solid border-0 border-indigo-300 pl-1 pr-1  pt-4 text-center">

        </div>
        <div v-if="Object.keys(maxORP).length > 0"
          class="text-xs text-purple-800 border-solid border-0 border-indigo-300 pl-1 pr-1  pt-4 text-center">

        </div>

      </div>

      <!-- GUHCL: before var ume -->

      <div class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4  ml-1 mr-1 pb-0 ">

        <div class="text-xs border-solid border-0 border-indigo-300 p-2 text-center pt-4">
          {{ this.objTemp.tipo }} {{ objTemp.unidad }}
        </div>
        <div v-if="Object.keys(reqO2).length > 0"
          class="text-xs   text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2  pt-4 text-center">
        {{ this.objO2Saturacion.tipo }} {{ objO2Saturacion.unidad }}
        </div>
        <div v-if="Object.keys(maxMgl).length > 0"
          class="text-xs   text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2  pt-4 text-center">
          {{ this.objO2Disuelto.tipo }} {{ this.objO2Disuelto.unidad }}
        </div>
        <div v-if="Object.keys(maxORP).length > 0"
          class="text-xs text-purple-800 border-solid border-0 border-indigo-300 pl-2 pr-2  pt-4 text-center">

          {{ this.maxORP.descripcion }} {{ maxORP_ume }}
        </div>
      </div>

      <!-- GUHCL: between var ume and val -->

      <div class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4  ml-1 mr-1 pb-0  ">

        <div
          class="text-xs   border-l-2 border-t-2 border-b-2 border-r-0  border-solid  border-indigo-300 p-2 text-center">
          {{ this.ulttemp }} <!-- Temp -->
        </div>
        <div v-if="Object.keys(reqO2).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center">
          {{ this.ultmaxmgl }} <!-- SdO -->
        </div>
        <div v-if="Object.keys(maxMgl).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center">
          {{ this.ultmgl }} <!-- OD -->
        </div>
        <div v-if="Object.keys(maxORP).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center bg-gray-200">
          {{ this.ultorp }} <!-- ORP -->
        </div>
      </div>

    <!-- GUHCL: between val and setpoints -->

      <div class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4  ml-1 mr-1 mb-4 ">

        <div class="text-xs border-solid border-0 border-indigo-300 p-2 text-center pt-7">
          Set Points
        </div>

        <div v-if="Object.keys(reqO2).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-0   bg-blue-600 border-indigo-300 p-2 text-center">
          <!-- SETPOINT SATURADO // requerido -->
          <input @click_desabilitado="openmodal('reqO2', reqO2_esDefault)" type="text" v-model="reqO2.value" :class="[
            'text-center w-full text-xs p-2 h-8 shadow-sm border-solid border-2 border-blue-600',
            reqO2_esDefault ? 'bg-orange-100' : 'bg-white']" />
        </div>

        <div v-if="Object.keys(maxMgl).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-0   bg-blue-600 border-indigo-300 p-2 text-center">
          <!-- SETPOINT OXIGENO DISUELTO // requerido -->
          <input @click_desabilitado="openmodal('maxMgl', maxMgl_esDefault)" type="text" v-model="maxMgl.value" :class="[
            'text-center w-full text-xs p-2 h-8 shadow-sm border-solid border-2 border-blue-600 ',
            maxMgl_esDefault ? 'bg-orange-100' : 'bg-white']" />
        </div>

        <div v-if="Object.keys(maxORP).length > 0"
          class="text-xs border-solid border-2 border-indigo-300 p-2 text-center  bg-purple-800">
          <!-- SET POINT ORP-->
          <!--  @click="openmodal('maxORP',maxORP_esDefault)"  -->
          <input type="text" v-model="maxORP.value" :class="[
            'text-center text-xs w-full p-2 h-8 shadow-sm border-solid border-purple-800 border-2 ',
            maxORP_esDefault ? ' bg-gray-200' : 'bg-white']" />
        </div>

      </div>

      </template>
      <!-- -- GUHCL: AFTER SETPOINTS -- -->

      <template v-if="inclFB">GraficoUnidadHighChartLive: before threshold<br></template>
      <ThresholdViewer :um="ThresholdViewerInputData" />
      <template v-if="inclFB">GraficoUnidadHighChartLive: after threshold<br></template>

      <br>  

    </div>
    <!-- GUHCL: END Si Vista Normal -->


    <div class="chart-container ">

      <!-- Activar "Leyendo datos ...", lg. -->
      <SpinnerLoading v-show="result_mediciones == false"></SpinnerLoading>

      <!-- Desactivar "Leyendo datos ...", lg. -->
      <!-- <SpinnerLoading v-show="false"></SpinnerLoading> -->

      <!-- GUHCL: BEG Si Vista Ampliada -->
      <template v-if="noShowSetpoint">

      <!-- GUHCL: ini leyendas en gráfica ampliada -->
      <div v-if="!esModal || esModal" :class="[
        'grid gap-0 mx-auto bg-gray-100 rounded-lg shadow-lg mb-1 pt-0',
        esModal === true ?
          inclSO ?
            'grid-cols-8 md:grid-cols-8 lg:grid-cols-8 pl-0 pr-0' :
            'grid-cols-6 md:grid-cols-6 lg:grid-cols-6 pl-0 pr-0' :
          'pl-1 pr-1 grid-cols-4 md:grid-cols-4 lg:grid-cols-4',
        noShowSetpoint ?
          inclSO ?
            'w-[1200px]' :
            'w-[650px]' :
          'w-full'
        ]">

  <!-- Primera columna -->
  <div class="text-center   pl-0 h-full   ">
   <span class="text-xs font-bold">{{ $t('o2_disuelto') }} mg/l</span>
  </div>

  <!-- Segunda columna -->
  <div class="text-center ml-1   mb-1 h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#01FFFF] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#0099FF] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left pr-3">
        <span class="text-[#00e0e0] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left ml-2">
        <span class="text-[#0099FF] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>

  <!-- Tercera columna -->
  <div class="text-center w-full h-full  ">
    <span class="text-xs font-bold">{{ $t('temperatura_celsius') }}</span>
  </div>

  <!-- Cuarta columna -->
  <div class="text-center mt-1   mb-2 h-full   ">
    <div class="mt-1 h-1 bg-[#FF6E00] rounded-lg shadow-lg w-full"></div>
  </div>

  <template v-if="inclSO">

  <!-- Quinta columna -->
  <div class="text-center mt-0  pl-1   h-full ">
    <span class="text-xs font-bold">{{ $t('oxigeno_saturado') }} %</span>
  </div>

  <!-- Sexta columna -->
  <div class="text-center  h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#7fff00] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#395172] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left pr-1">
        <span class="text-[#69ce04] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left ml-2">
        <span class="text-[#395172] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>

  </template>

   <!-- sept columna -->
        <div v-if="esModal" class="text-center mt-0">
          <a @click="loadGraficoHistorial()" href="#"
            class=" m-2 group flex flex-col items-center justify-between p-3   rounded-lg transition duration-150 ease-in-out hover:bg-green-50 bg-gray-200">
            <p class="text-xs text-gray-900">{{ $t('calendario') }}</p>
          </a>
        </div>

        <!-- oct columna -->
        <div v-if="esModal" class="text-center mt-0">
          <a @click="loadOpcionesHoras(true)" href="#"
            class=" m-2 group flex flex-col items-center justify-between p-3   rounded-lg transition duration-150 ease-in-out hover:bg-green-50 bg-gray-200">
            <p class="text-xs text-gray-900">
              {{ $t('horas') }}
            </p>
          </a>
        </div>

      </div>
      <!-- GUHCL: fin leyendas en gráfica ampliada -->

      </template>
      <!-- GUHCL: END: Si Vista Ampliada -->


      <div class="w-full flex justify-center">

        <AlertDummy v-show="glosaDummyO2Disuelto != ''" :glosa="glosaDummyO2Disuelto"></AlertDummy>
        <AlertDummy v-show="glosaDummyO2Saturado != ''" :glosa="glosaDummyO2Saturado"></AlertDummy>
        <AlertDummy v-show="glosaDummyTemperatura != ''" :glosa="glosaDummyTemperatura"></AlertDummy>
        <AlertDummy v-show="glosaDummyOzono != ''" :glosa="glosaDummyOzono"></AlertDummy>

      </div>


      <!-- GUHCL: ini curvas al día -->
      <div class="w-full     " v-if="!noShowSetpoint" @click.prevent="openModalGrafico(objJaula)">

        <highcharts :options="chartOptions"></highcharts>

      </div>
      <div v-else class="w-full    ">

        <highcharts :options="chartOptions"></highcharts>

      </div>
      <!-- GUHCL: fin curvas al día -->


    </div>
    <!-- GUHCL: end chart-container -->

    <div class="chart-container">
      <div id="divfec" class="w-full flex justify-between  pr-4">
        <div class="f1 pl-4 text-xs text-center">
          <!--    {{ firstdate }}<br>{{ firsthour }}-->
          {{ fechaInicialParche }}
          <br>
          {{ horaInicialParche }}
        </div>
        <div class="flex-grow text-xs text-center">
          <!--  {{ middledate }}<br>{{ middlehour }} -->
          {{ fechaMitadParche }}
          <br>
          {{ horaMitadParche }}
        </div>
        <div class="f2 text-xs text-center ml-1 pr-12 mr-12 ">
          <!--     {{ lastdate }}<br>{{ lasthour }}-->
          {{ fechaFinalParche }}
          <br>
          {{ horaFinalParche }}
        </div>
      </div>
    </div>
    <!-- GUHCL: end chart-container -->


    <textarea id="adjustable-textarea" class="w-full  p-2 border border-gray-300 rounded   text-xs
    focus:outline-none focus:ring-2 focus:ring-blue-500 text hidden " v-model="this.fs2"></textarea>
    <!-- hidden -->
    <!-- {{ this.chartOptions.series[0].zones  }} -->
  </div>

  <template v-if="inclFB">GraficoUnidadHighChartLive: end template<br></template>

</template>
<style scoped>
.o2{ background-color: var(--color-o2);}
.o3{ background-color: var(--color-o3);}
</style>
<script>

import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import SpinnerLoading from "../SpinnerLoading";

import AlertDummy from "../AlertDummy.vue";

import EditHorasModal from './EditHorasModal.vue';
import axios from "axios";
import i18n from "@/i18n";

import ThresholdViewer from './viewers/Threshold.vue'; // ThresholdViewer
import { getParameterThresholdSetArray, debugThresholdSearch } from './processors/Threshold.js'; // ThresholdProcessor
//import { handler } from "daisyui";
import { healthData2Status, healthProcessorDebug } from './processors/healthProcessor.js'; // HealthProcessor

stockInit(Highcharts);
//const colors = Highcharts.getOptions().colors;
Highcharts.setOptions({
  chart: {

  },

});

export default {
  props: ["propIdFaena","objJaula", "noShowSetpoint", "startDate", "endDate", "esModal", "invervalohoraslive", "abreModalHoras"],
  emits: ["ampliaGraficoLive", "muestraFoto", "fecha_hasta", 'healthDataUpdate', 'healthStatusUpdate'  ],

  components: {
    highcharts: Chart,
    SpinnerLoading,
    EditHorasModal,
    AlertDummy,
    ThresholdViewer
  },

  data: function () {
    return {
      vista:'',
      frecuencia_minutos:'',

      chartOptions: {
        chart: { type: 'line' },
        legend: { enabled: false },
        plotOptions: {
          line: {
            dataLabels: { enabled: false },
            enableMouseTracking: true,
          },
        },
        series: [
          {
            name: '',
            data: [],
            yAxis: 0,
            zones: [],
            zoneAxis: 'x',
            marker: { enabled: false },
          },
          {
            name: '',
            data: [],
            yAxis: 1,
            marker: { enabled: false },
          },
          {
            name: '',
            data: [],
            yAxis: 2,
            zones: [],
            zoneAxis: 'x',
            marker: { enabled: false },
            visible: false, // ⬅️  oculta  SATURADO
          },
        ],
        title: { text: '' },
        tooltip: {},
        xAxis: {
          categories: [],
          labels: {
            enabled: true,
            lineColor: 'gray',
          },
        },
        colors: ['#0099ff', '#ff6e00', '#395172'],
        yAxis: [
          {
            title: {
              text: '',
              style: { color: '#0037ff' },
            },
            min: 0,
            max: 0,
            labels: {
              style: { color: '#0037ff' },
            },
             opposite: false
          },
          {
            opposite: true,
            title: {
              text: '°C',
              style: { color: '#ff6e00' },
            },
            min: 0,
            max: 0,
            labels: {
              style: { color: '#ff6e00' },
            },
          },
          {
            opposite: true,
            title: {
              text: '',
              style: { color: '#395172' },
            },
            min: 0,
            max: 0,
            labels: {
              style: { color: '#395172' },
            },
            visible: false, // ⬅️   oculta  SATURADO
          },
        ],
      },

      datosSetPoint: {},
      descripcionSetPoint: '',
      dispositivo: '',
      fFinal: '',
      fInicial: '',
      fechaFinalParche: '',
      fechaInicialParche: '',
      fechaMitadParche: '',
      firstdate: '',
      firsthour: '',
      frecuenciaIntervaloHoras: 0, // selector intervalo horas
      fs: '',
      fs2: '',
      glosaDummyO2Disuelto: '',
      glosaDummyO2Saturado: '',
      glosaDummyOzono: '',
      glosaDummyTemperatura: '',
      granularity: '',
      horaFinalParche: '',
      horaInicialParche: '',
      horaMitadParche: '',
      id1: 0,
      id2: 0,
      idEstado: 5,
      idJaula: 0,
      idSensorAFiltrar0: 0,
      idSensorAFiltrar1: 0,
      inclFB: false,
      inclSO: false,
      inclSP: false,
      lastdate: '',
      lasthour: '',
      maxMgl: {}, // OD sp
      maxMgl_esDefault: '',
      maxMgl_tipo: '',
      maxMgl_ume: '',
      maxORP: {},
      maxORP_esDefault: '',
      maxORP_tipo: '',
      maxORP_ume: '',

      maxpuntos: 0,
      middledate: '',
      middlehour: '',

      modalgraficostate: false,
      modalstate: this.abreModalHoras,
      objJaulaSeleccionada: {},
      objRangoFechas: {},
      reqO2: {},
      reqO2_esDefault: '',
      reqO2_tipo: '',
      reqO2_ume: '',
      result_mediciones: true,
      result_mediciones_haydatos: false,
      saturacion: '--',
      sensor: [{ id: '', nombre: '' }, { id: '', nombre: '' }],
      sensores: [],
      setpoint1: 6.2,
      setpoint2: 300,
      showModalRangoFechas: false,
      temperatura: '--',
      tipo1: '',
      tipo2: '',
      ultfecha: '',
      ulttemp: '--',  // Temp
      ultmaxmgl: '--', // SdO
      ultmgl: '--', // OD
      ultorp: '---', // ORP
      ume1: '',
      ume2: '',
      valorMinY_O2: 0,
      valorMaxY_O2: 0,
      valorMaxY_temp: 0,
      valorMinY_temp: 0,
      valorMaxY_o2saturado: 0,
      valorMinY_o2saturado: 0,
      objTemp: {},
      objO2Disuelto: {},
      objO2Saturacion: {},

      ptsa: [ // ThresholdProcessor output data: Parameter Thresholds Set Array pre-initialization
        { idPar: null, upper: { val: null, mod: false, ctl: false }, lower: { val: null, mod: false, ctl: false } },
        { idPar: null, upper: { val: null, mod: false, ctl: false }, lower: { val: null, mod: false, ctl: false } },
        { idPar: null, upper: { val: null, mod: false, ctl: false }, lower: { val: null, mod: false, ctl: false } },
        { idPar: null, upper: { val: null, mod: false, ctl: false }, lower: { val: null, mod: false, ctl: false } }
      ],

      hpia: [ // health processor input array = health data
        { idPar: null, cntrl: null, upval: null, measu: null, loval: null },
        { idPar: null, cntrl: null, upval: null, measu: null, loval: null },
        { idPar: null, cntrl: null, upval: null, measu: null, loval: null },
        { idPar: null, cntrl: null, upval: null, measu: null, loval: null }
      ],

      hpov: null //health processor output value = health status

    };
  },
  computed: {
    ThresholdViewerInputData() {
      return {
        // Fila 1 (variables)
        a1: this.hpov,
        b1: this.objTemp.tipo,
        c1: this.objO2Saturacion.tipo,
        d1: this.objO2Disuelto.tipo,
        e1: this.maxORP.descripcion,
        // Fila 2 (unidades)
        a2: '',
        b2: this.objTemp.unidad,
        c2: this.objO2Saturacion.unidad,
        d2: this.objO2Disuelto.unidad,
        e2: this.maxORP_ume,
        // Fila 3 (umbrales superiores) -- todas las variables definitivas están pendientes
        a3: 'Umbral superior', 
        b3: this.ptsa[0].upper.val, //null,
        b3_m: this.ptsa[0].upper.mod,
        b3_c: this.ptsa[0].upper.ctl,
        c3: this.ptsa[1].upper.val, //reqO2.value+10, 
        c3_m: this.ptsa[1].upper.mod, //!this.reqO2_esDefault,         // ? fondo resaltado : fondo normal
        c3_c: this.ptsa[1].upper.ctl, //false,                             // ? borde resaltado : borde normal
        d3: this.ptsa[2].upper.val, //this.maxMgl.value+1, 
        d3_m: this.ptsa[2].upper.mod, //!this.maxMgl_esDefault,        // ? fondo resaltado : fondo normal
        d3_c: this.ptsa[2].upper.ctl, //true,                             // ? borde resaltado : borde normal     
        e3: this.ptsa[3].upper.val, //this.maxORP.value+50, 
        e3_m: this.ptsa[3].upper.mod, //!this.maxORP_esDefault,        // ? fondo resaltado : fondo normal
        e3_c: this.ptsa[3].upper.ctl, //false,                            // ? borde resaltado : fondo normal
        // Fila 4 (mediciones)
        a4: 'Medición', 
        b4: this.ulttemp,                    // Temp
        c4: this.ultmaxmgl,                  // SdO
        d4: this.ultmgl,                     // OD
        e4: this.ultorp,                     // ORP
        // Fila 5 (umbrales inferiores) -- todas las variables definitivas están pendientes
        a5: 'Umbral inferior', 
        b5: this.ptsa[0].lower.val, //null, 
        b5_m: this.ptsa[0].lower.mod, //false,
        b5_c: this.ptsa[0].lower.ctl, //false,
        c5: this.ptsa[1].lower.val, //this.reqO2.value-10, 
        c5_m: this.ptsa[1].lower.mod, //!this.reqO2_esDefault,         // ? fondo resaltado : fondo normal
        c5_c: this.ptsa[1].lower.ctl, //false,                             // ? borde resaltado : borde normal
        d5: this.ptsa[2].lower.val, //this.maxMgl.value-1, 
        d5_m: this.ptsa[2].lower.mod, //!this.maxMgl_esDefault,        // ? fondo resaltado : fondo normal
        d5_c: this.ptsa[2].lower.ctl, //true,                             // ? borde resaltado : borde normal     
        e5: this.ptsa[3].lower.val, //this.maxORP.value-50, 
        e5_m: this.ptsa[3].lower.mod, //!this.maxORP_esDefault,        // ? fondo resaltado : fondo normal
        e5_c: this.ptsa[3].lower.ctl // false,                             // ? borde resaltado : fondo normal
      }
    }
  },
  methods: {
    loadOpcionesHoras(valor) {
      this.modalstate = valor;
    },
    loadGraficoHistorial() {
      this.$store.state.gotolive = false
      this.$emit("loadGraficoHistorial", this.objJaula);
    },
    closeModalRangoFechas() {
      this.showModalRangoFechas = false;
    },

    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2)
    },
    getRndUno(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(1)
    },
    propagajaula() {
      this.$emit("muestraFoto", this.idJaula, this.label);
    },
    polldata() {
      this.polling = setInterval(() => {
        this.getdataendpoint();
      }, 30000); //
    },

    closeModal() {
      this.modalstate = false
    },

    updateRangoHoras(numero) {
      this.result_mediciones = false;
      this.frecuenciaIntervaloHoras = parseInt(numero);
      this.modalstate = false;
      this.getdataendpoint();

    },
 


    async getdataendpoint() {
      if (this.modalstate) {
        return false;
      }
      let resta_ms = 0
      this.result_mediciones = false;
      this.frecuencia_minutos = 0;

     this.vista = this.noShowSetpoint ? 'live-ampliado' : 'live-no-ampliado';
      if (this.frecuenciaIntervaloHoras) 
      {
        this.frecuencia_minutos = this.frecuenciaIntervaloHoras * 60;
        switch (this.frecuenciaIntervaloHoras) {
          case 2:
            resta_ms = 7200000;
            break;
          case 4:
            resta_ms = 14400000;
            break;
          case 6:
            resta_ms = 21600000;
            break;
          case 12:
            resta_ms = 43200000;
            break;
          case 24:
            resta_ms = 86400000;
            break;
          default:
            console.warn(`Frecuencia no soportada: ${this.frecuenciaIntervaloHoras}`);
        }
        this.granularity = this.$store.getters.calculaPuntosGranularidad(this.frecuencia_minutos, this.vista)
      } else {
        if (this.noShowSetpoint) {
          // this.vista ampliada 
          this.frecuencia_minutos = 24 * 60
        } else {
           // this.vista no ampliada 
          this.frecuencia_minutos = 2 * 60
        }
        this.granularity = this.$store.getters.calculaPuntosGranularidad(this.frecuencia_minutos, this.vista)
        switch (this.granularity) {
          case '':
            resta_ms = 7200000;
            break;
          case 'HOUR':
            resta_ms = 86400000;
            break;
          case 'DAY':
            resta_ms = 1036800000;
            break;
        }
      }

 

      let objFecha =this.$store.getters.fechaHoraActual(this.propIdFaena);
      const y = objFecha.getFullYear;
      const m = String(objFecha.getMonth) .padStart(2, '0'); 
      const d = String(objFecha.getDate).padStart(2, '0');
      const h = String(objFecha.getHours).padStart(2, '0');
      const min = String(objFecha.getMinutes).padStart(2, '0');
      const s = String(objFecha.getSeconds).padStart(2, '0');
      let fechaHoraStr = `${y}-${m}-${d}T${h}:${min}:${s}`;
      if (this.injecta_fecha) {
        fechaHoraStr = `${this.injecta_fecha}T${h}:${min}:${s}`;
      }  

      let objFechaHora = this.$store.getters.objDate(fechaHoraStr,`${h}:${min}:${s}`,this.propIdFaena);
      var nF = {
        year: objFechaHora.getFullYear,
        month: ('0' + (objFechaHora.getMonth )).slice(-2),
        day: ('0' + objFechaHora.getDate).slice(-2),
        hours: ('0' + objFechaHora.getHours).slice(-2),
        minutes: ('0' + objFechaHora.getMinutes).slice(-2),
        seconds: ('0' + objFechaHora.getSeconds).slice(-2)
      };
     

      this.fFinal = `${nF.year}-${nF.month}-${nF.day}T${nF.hours}:${nF.minutes}:${nF.seconds}`;
      //////console.log('dateFactory (0)',this.fFinal);
      
      const f =this.$store.getters.dateFactory(this.fFinal,this.propIdFaena);
      let fechaHoraIso = f.subtractMillis( resta_ms); 
      //////console.log('dateFactory (3) ',fechaHoraIso);
      //2025-07-08T14:45:59.000-04:00

      let fecha = fechaHoraIso.substring(0, 19);
      //fecha = fecha.replace('T', ' ');
      this.fInicial = fecha;
      ////console.log('dateFactory (4) ',this.fInicial);
      
      if (!this.idJaula) {
        return false;
      }
      if (!this.sensor) {
        return false;
      }


      const apiKey = this.$store.state.login.tokenLogin;

      const data = {
        idUnit: this.idJaula,
        tsi: `${this.fInicial}`,
        tsf: `${this.fFinal}`,
        granularity: `${this.granularity}`
      };

      const fetchData = async () => {
        try {
          const url = "/api/mon/getUnitData";
          const response = await axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${apiKey}`

            }
          });

          this.glosaDummyO2Saturado = '';
          this.glosaDummyO2Disuelto = '';
          const datos = response.data.payload.sensors;
          this.fs2 = JSON.stringify(datos);
          if (Array.isArray(datos) && datos.length == 0) {
            return false;
          }

          this.valorMaxY_O2 = 0;
          this.valorMinY_O2 = 0;
          this.valorMaxY_temp = 0;
          this.valorMinY_temp = 0;
          this.valorMaxY_o2saturado = 0;
          this.valorMinY_o2saturado = 0;

          let temperaturaValues = [];
          let oxigenoValues = [];
          let oxigenoSaturadoValues = [];
          let orpValues = [];

          this.idSensorAFiltrar1 = this.objJaula.sensores[0]; // viene de props

          datos.filter(sensor => sensor.id === this.idSensorAFiltrar1)
            .forEach(sensor => {
              let indice = 0;

              sensor.params.forEach(param => {
                let id = param.id;

                if (param.injectionType === 'dummy') {
                  const gas = param.gas;

                  switch (id) {
                    case 1:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyTemperatura =  i18n.global.t( "temperatura_simulada");
                      }
                      break;
                    case 4:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyOzono = `${gas} ${i18n.global.t( "disuelto_simulado")}`;
                      }
                      break;
                    case 5:
                      this.glosaDummyO2Disuelto = `${gas} ${i18n.global.t( "disuelto_simulado")}`;
                      break;
                    case 6:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyO2Saturado = `${gas}  ${i18n.global.t( "saturado_simulado")}`;
                      }
                      break;
                  }
                }


                //let splicedData = [...param.values].splice(-2);

                let splicedData = [...param.values];

                splicedData.forEach(valor => {

                  // contiene:  {'value':valor.value,'ts':valor.ts}

                  switch (id) {
                    case 1:
                      temperaturaValues.push({ ...valor });
                      this.valorMaxY_temp <= valor.value ? (this.valorMaxY_temp = valor.value) : (this.valorMinY_temp = valor.value);
                      this.ajusteY()
                      break;
                    case 5:
                      oxigenoValues.push({ ...valor });
                      if (indice == 0) {
                        this.valorMinY_O2 = valor.value;
                        this.valorMaxY_O2 = valor.value;
                      } else {
                        if (valor.value > this.valorMaxY_O2) {
                          this.valorMaxY_O2 = valor.value;

                        } else {
                          if (valor.value < this.valorMinY_O2) {
                            this.valorMinY_O2 = valor.value
                          }
                        }
                      }
                      indice++;
                      this.ajusteY()
                      break;
                    case 4:
                      this.ultorp = valor.value > 0 ? valor.value.toFixed(2) : '--'; // ORP
                      orpValues.push({ ...valor });
                      break;
                    case 6:

                      oxigenoSaturadoValues.push({ ...valor });
                      if (indice == 0) {
                        this.valorMinY_o2saturado = valor.value;
                        this.valorMaxY_o2saturado = valor.value;
                      } else {
                        if (valor.value > this.valorMaxY_o2saturado) {
                          this.valorMaxY_o2saturado = valor.value;

                        } else {
                          if (valor.value < this.valorMinY_o2saturado) {
                            this.valorMinY_o2saturado = valor.value
                          }
                        }
                      }
                      indice++;
                      this.ajusteY()


                      this.ultmaxmgl = valor.value.toFixed(2); // SdO
                      break;

                  }


                  this.result_mediciones_haydatos = true;

                  const exists = this.$store.state.objStatusJaulas.some(jaula => jaula.idJaula === this.idJaula);
                  if (!exists) {
                    this.$store.state.objStatusJaulas.push({ idJaula: this.idJaula, status: true });
                  }
                });
              });
            });


          return new Promise((resolve, reject) => {
            try {
              this.chartOptions.xAxis.categories = []
              let mediciones_oxigeno = [];
              let mediciones_o2saturado = [];
              let zones_oxigeno = []
              let zones_o2saturado = []
              let mediciones_temp = [];

              let categorias = [];

              let ultimo_injection_tag;
              let ultimo_injection_tag_o2saturado;

              temperaturaValues.forEach((mobile) => {


                let med = mobile["value"];
                mediciones_temp.push(med);
                this.ulttemp = med.toFixed(2); // Temp
                //////console.log(med)
                //////console.log(year)


              });

              let mitad = 0;
              mitad = Math.round(oxigenoValues.length / 2);


              oxigenoSaturadoValues.forEach((mobile, index) => {

                // zonas contiene  la posicion del array series  

                if (index == 0) {

                  ultimo_injection_tag_o2saturado = mobile["injection"]

                } else {

                  if (mobile["injection"] !== ultimo_injection_tag_o2saturado) {

                    zones_o2saturado.push({
                      tag: mobile["injection"],
                      value: index,
                      color: ultimo_injection_tag_o2saturado == false && mobile["injection"] == true ? '#7FFF01' : '',
                    })
                  
                  } else {
                    zones_o2saturado.push({
                      tag: mobile["injection"],
                      value: index,
                      color: ultimo_injection_tag_o2saturado == true ? '#7FFF01' : '',
                    })


                  }
                   ultimo_injection_tag_o2saturado = mobile["injection"];
                  
                  this.$store.dispatch("updStateInyeccion", { 
                     
                      idJaula: this.idJaula, 
                      estado: ultimo_injection_tag_o2saturado 
                  });


                }


                let med = mobile["value"];
                mediciones_o2saturado.push(med);
                this.o2saturadp_ultmgl = med.toFixed(2);


              });


              oxigenoValues.forEach((mobile, index) => {

                // zonas contiene  la posicion del array series  

                if (index == 0) {

                  ultimo_injection_tag = mobile["injection"]

                } else {

                  if (mobile["injection"] !== ultimo_injection_tag) {

                    zones_oxigeno.push({
                      tag: mobile["injection"],
                      value: index,
                      color: ultimo_injection_tag == false && mobile["injection"] == true ? 'cyan' : '',
                    })

                  } else {
                    zones_oxigeno.push({
                      tag: mobile["injection"],
                      value: index,
                      color: ultimo_injection_tag == true ? 'cyan' : '',
                    })


                  }

                  ultimo_injection_tag = mobile["injection"];

                }


                let med = mobile["value"];
                mediciones_oxigeno.push(med);
                this.ultmgl = med.toFixed(2); // OD

                let hora_minuto = mobile["ts"].substr(mobile["ts"].length - 8, mobile["ts"].length);
                hora_minuto = hora_minuto.substr(0, 5, 2);
                categorias.push(hora_minuto);
                //this.fs2 = index + " " + mobile["ts"] + "  " + med + " " + mobile["injection"] + "\n" + this.fs2;

                let t = mobile["ts"].split(" ")[0].split("-");
                const fects = t[2] + "-" + t[1];

                switch (index) {
                  case 0:
                    this.fechaInicialParche = fects;
                    this.horaInicialParche = mobile["ts"].split(" ")[1];
                    break;
                  case mitad:

                    this.fechaMitadParche = fects;
                    this.horaMitadParche = mobile["ts"].split(" ")[1];
                    break;
                  default:
                    this.fechaFinalParche = fects;
                    this.horaFinalParche = mobile["ts"].split(" ")[1];

                }


              });


              this.chartOptions.xAxis.categories = categorias;
              this.chartOptions.series[0].data = mediciones_oxigeno;
              this.chartOptions.series[0].zones = zones_oxigeno;

              this.chartOptions.series[1].data = mediciones_temp;

              this.chartOptions.series[2].data  = mediciones_o2saturado;
              this.chartOptions.series[2].zones = zones_o2saturado;
              resolve({
                temperaturaValues,
                oxigenoValues,
                categorias,
                ultfecha: this.ultfecha,
                firstdate: this.firstdate,
                firsthour: this.firsthour,
                middledate: this.middledate,
                middlehour: this.middlehour,
                lastdate: this.lastdate,
                lasthour: this.lasthour,
                ultmgl: this.ultmgl
              });
            } catch (error) {
              reject(error);
            }
          });
        } catch (error) {
          console.error("Error al obtener datos:", error);
          return false;
        }
      };

      fetchData().then(() => {


        this.result_mediciones = true;

      }).catch(error => {
        console.error("Error processing data:", error);
      });




    },

    openModalGrafico(obj) {

      this.$emit("ampliaGraficoLive", obj);
    },
    openmodal(tag   ) {
     
      this.datosSetPoint = {}

      if (tag == 'maxORP') {
        this.datosSetPoint.value = this.maxORP.value;
        this.datosSetPoint.descripcion = this.maxORP.descripcion;

      }
      if (tag == 'reqO2') {
        this.datosSetPoint.value = this.reqO2.value;
        this.datosSetPoint.descripcion = this.reqO2.descripcion;
        this.datosSetPoint.tipo = tag;
      }
      if (tag == 'maxMgl') {
        this.datosSetPoint.value = this.maxMgl.value;
        this.datosSetPoint.descripcion = this.maxMgl.descripcion;
        this.datosSetPoint.tipo = tag;
      }
      ////console.log('descripcionSetPoint', this.descripcionSetPoint)

      this.modalstate = true
    },
    getUme() {

      let setpoints = this.objJaula.setpoints;

      if (Array.isArray(setpoints) && setpoints.length > 0) {
        this.filtraSetPoints(setpoints);
      }

      if (Object.keys(this.reqO2).length > 0) {

        this.reqO2_ume = this.parametroSetPointsLogin[this.reqO2.idPar].unMed;
      }
      if (Object.keys(this.maxMgl).length > 0) {

        this.maxMgl_ume = this.parametroSetPointsLogin[this.maxMgl.idPar].unMed;
      }
      if (Object.keys(this.maxORP).length > 0) {

        this.maxORP_ume = this.parametroSetPointsLogin[this.maxORP.idPar].unMed;
      }

    },

    getDefaultSetPoints() {

      let defaultsetpoints = this.$store.state.login.userLogin.info.default_setpoints;
      if (Array.isArray(defaultsetpoints) && defaultsetpoints.length > 0) {
        this.filtraDefaultSetPoints(defaultsetpoints);
      }

      if (Object.keys(this.reqO2).length > 0) {

        this.reqO2_ume = this.reqO2.unMedida;
        this.reqO2_esDefault = this.reqO2.esDefault;
        this.reqO2.value = this.reqO2.valor;
         this.reqO2.descripcion = i18n.global.t('oxigeno_saturado')
         
      }
      if (Object.keys(this.maxMgl).length > 0) {

        this.maxMgl_ume = this.maxMgl.unMedida;
        this.maxMgl_esDefault = this.maxMgl.esDefault;
        this.maxMgl.value = this.maxMgl.valor;  
         this.maxMgl.descripcion = i18n.global.t('oxigeno_disuelto')
      }
      if (Object.keys(this.maxORP).length > 0) {

        this.maxORP_ume = this.maxORP.unMedida;
        this.maxORP_esDefault = this.maxORP.esDefault;
        this.maxORP.value = this.maxORP.valor;
      }

    },
    ajusteY() {


      let estimadoMin = this.valorMinY_O2 - 0.4;
      let nuevoValorMin = estimadoMin < 0 ? 0 : estimadoMin;
      let nuevoValorMax = this.valorMaxY_O2 + 0.4;
      // this.fs = nuevoValorMin +  " " + nuevoValorMax

      let estimadoMin1 = this.valorMinY_temp - 8;
      let nuevoValorMin1 = estimadoMin1 < 0 ? 0 : estimadoMin1;
      let nuevoValorMax1 = this.valorMaxY_temp + 0.5;


      let estimadoMin2 = this.valorMinY_o2saturado - 8;
      let nuevoValorMin2 = estimadoMin2 < 0 ? 0 : estimadoMin2;
      let nuevoValorMax2 = this.valorMaxY_o2saturado + 0.5;


      // ////console.log(nuevoValorMin, nuevoValorMax, nuevoValorMin1, nuevoValorMax1)

      // this.chartOptions.yAxis[0].title.text = this.maxMgl_ume;
      this.chartOptions = {
        ...this.chartOptions,

        yAxis: [
          {
            ...this.chartOptions.yAxis[0],
            max: nuevoValorMax,
            min: nuevoValorMin,


          },
          {
            ...this.chartOptions.yAxis[1],
            max: nuevoValorMax1,
            min: nuevoValorMin1,

          }, 
          {
            ...this.chartOptions.yAxis[2],
            max: nuevoValorMax2,
            min: nuevoValorMin2,

          },
        ],

      };



    },

    getSensores() {
      //console.log('getSensores')
      //let arrDefaultSetpoints = this.$store.state.login.userLogin.info.default_setpoints;

      let parametros_sensores = this.$store.state.login.userLogin.info.parametro_sensores;

      let sensores = this.objJaula.sensores
      //console.log('parametros_sensores', parametros_sensores);
      let parametros_filtrados = this.filtrarParametros(sensores, parametros_sensores);
      this.ume1 = 'none'
      this.ume2 = 'none'
      if (Array.isArray(parametros_filtrados) && parametros_filtrados.length > 0) {


        this.id0 = parametros_filtrados[0]?.id ?? 'none';
        this.id1 = parametros_filtrados[1]?.id ?? 'none';
        let id2 = parametros_filtrados[2]?.id ?? 'none';

        this.tipo0 = parametros_filtrados[0]?.tipo ?? 'none';
        this.tipo1 = parametros_filtrados[1]?.tipo ?? 'none';
        this.tipo0 = parametros_filtrados[0]?.tipo ?? 'none';
        let tipo2 = parametros_filtrados[2]?.tipo ?? 'none';

        this.ume0 = parametros_filtrados[0]?.unidad ?? 'none';
        this.ume1 = parametros_filtrados[1]?.unidad ?? 'none';
        let ume2 = parametros_filtrados[2]?.unidad ?? 'none';

        if (this.id0 != '') {
          this.sensor[1].id = this.id0;  // oxigeno disuelto

          // leyenda   para el grafico
          this.chartOptions.series[1].name = this.tipo0 + ' ' + this.ume0;
        }
        if (this.id1 != '') {
          this.sensor[0].id = this.id1;
          // para leyenda del grafico
          this.chartOptions.series[0].name = this.tipo1 + ' ' + this.ume1;
        }
   if ( id2 != '') {
         
          this.chartOptions.series[2].name =  tipo2 + ' ' +  ume2;
        }
      }
    },
    getSetPoints() {

      let parametros_sensores = this.$store.state.login.userLogin.info.parametro_sensores;
      let sensores = this.objJaula.sensores
      let parametros_filtrados = this.filtrarParametros(sensores, parametros_sensores);
      this.objTemp = parametros_filtrados.filter(parametro => parametro).find(param => param.id === 1) ?? {};
      this.objTemp && (this.objTemp.tipo = i18n.global.t('temperatura'));

      this.objO2Disuelto = parametros_filtrados.filter(parametro => parametro).find(param => param.id === 5) ?? {};
      this.objO2Saturacion = parametros_filtrados.filter(parametro => parametro).find(param => param.id === 6) ?? {};
      
      this.objO2Saturacion && (this.objO2Saturacion.tipo = i18n.global.t('oxigeno_saturado'));
      this.objO2Disuelto && (this.objO2Disuelto.tipo = i18n.global.t('oxigeno_disuelto'));

      /*
      parametros_filtrados
      0 {id: 1, tipo: 'Temperatura', unidad: '°C'}
      1 {id: 5, tipo: 'Oxígeno Disuelto', unidad: 'mg/l'}
      2 {id: 6, tipo: 'Saturación de Oxígeno', unidad: '%'}
      3 {id: 8, tipo: 'Presion', unidad: 'torr'}
      */



    },
    filtraSetPoints(setpoints) {
      //console.log('setpoints', setpoints)
      setpoints.forEach(s => {
        if (this.tagMappingSetPointsLogin[s.idPar]) {
          this[this.tagMappingSetPointsLogin[s.idPar]] = { 'id': s.id, 'idPar': s.idPar, 'value': s.value };
        }
      })
    },
    filtraDefaultSetPoints(defaultsetpoints) {


      let setpoints = this.objJaula.setpoints;
      defaultsetpoints.forEach(s => {
        let obj = { 'id': s.id, 'idPar': s.idPar, 'descripcion': s.descripcion, 'tipo': s.tipo, 'unMedida': s.unMedida };
        // busca valor setpoint en objJaula.setpoints


        // si no lo encuentra, poner valor por defecto  s.valor
        let resp = this.filtraValorSetPoint(setpoints, s) // asigna valor específico de unidad o, en su defecto, valor universal
        switch (s.idPar) {
          case 4: this.maxORP = obj;
            this.maxORP.valor = resp[0]
            this.maxORP.esDefault = resp[1]
            break;
          case 5: this.maxMgl = obj
            this.maxMgl.valor = resp[0]
            this.maxMgl.esDefault = resp[1]
           this.maxMgl.descripcion = i18n.global.t('oxigeno_disuelto')
            break;
          case 6: this.reqO2 = obj;
            this.reqO2.valor = resp[0]
            this.reqO2.esDefault = resp[1]
            this.reqO2.descripcion = i18n.global.t('oxigeno_saturado')
            break;
        }

      })
    },
    // retorna un arreglo con 2 elementos simples: valor por defecto o específico e indicador verdadero para global y falso para unidad
    filtraValorSetPoint(setpoints, s) {
      let filteredData = setpoints.filter(item => item.idPar === s.idPar);
      let valor = 0;
      let esDefault;
      if (filteredData && Array.isArray(filteredData)) {
        valor = filteredData[0] ? filteredData[0].value : s.valor;
        esDefault = filteredData[0] ? false : true;

      }


      return [valor, esDefault];
    },
    filtrarParametros(sensores, parametro_sensores) {
      let resultados = [];

      sensores.forEach(sensorId => {
        parametro_sensores.forEach(parametro => {
          if (sensorId === parametro.id) {
            resultados = resultados.concat(parametro.parametros);
          }
        });
      });

      return resultados;
    },

    healthDataUpdate() {
      this.hpia = [
        {
          idPar: 1,
          cntrl: this.ptsa[0].upper.ctl || this.ptsa[0].lower.ctl,
          upval: this.ptsa[0].upper.val,
          measu: this.ulttemp, // Temp
          loval: this.ptsa[0].lower.val
        },
        {
          idPar: 6,
          cntrl: this.ptsa[1].upper.ctl || this.ptsa[1].lower.ctl,
          upval: this.ptsa[1].upper.val,
          measu: this.ultmaxmgl, // SdO
          loval: this.ptsa[1].lower.val
        },
        {
          idPar: 5,
          cntrl: this.ptsa[2].upper.ctl || this.ptsa[2].lower.ctl,
          upval: this.ptsa[2].upper.val,
          measu: this.ultmgl, // OD
          loval: this.ptsa[2].lower.val
        },
        {
          idPar: 4,
          cntrl: this.ptsa[3].upper.ctl || this.ptsa[3].lower.ctl,
          upval: this.ptsa[3].upper.val,
          measu: this.ultorp, // ORP
          loval: this.ptsa[3].lower.val
        }
      ];
      this.$emit('healthDataUpdate', this.hpia);
    },

    healthStatusUpdate() {
      this.hpov=healthData2Status(this.hpia);
      this.$emit('healthStatusUpdate', this.hpov);
    },

    healthDebugShow() {
      healthProcessorDebug(this.hpia, this.hpov);
    }

  },
  watch: {

    injecta_fecha: function () {
      if (!this.chart) return; //  
      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[1].data = [0];
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[0].zones = [];


  
      this.result_mediciones = false;

    },
    injecta_hora: function () {
      //console.log('injecta_fecha:', valor)
      this.result_mediciones = false;
    },
    invervalohoraslive: function (valor) {
      this.result_mediciones = false;
      this.frecuenciaIntervaloHoras = parseInt(valor);
      this.getdataendpoint();
    },

    ultmgl: {
      handler() {
        this.healthDataUpdate();
        this.healthStatusUpdate();
        this.healthDebugShow();
      },
      deep: true
    },

  },
  created() { },
  mounted() {

    const setpoints = this.$store.state.login.userLogin.info.default_setpoints;
    let resultado = setpoints.find(item => item.idPar === 5);
    let tipoMedicion = i18n.global.t('oxigeno_disuelto') 
    let umeMedicion = resultado ? resultado.unMedida : null;
    let tituloY = tipoMedicion + ' ' + umeMedicion;
    this.chartOptions.yAxis[0].title.text = tituloY;
    this.maxpuntos = this.$store.getters.getMaxPuntosLiveNormal;
    this.dispositivo = this.$store.getters.detectarDispositivo;

    resultado = setpoints.find(item => item.idPar === 1);
    tipoMedicion = resultado ? resultado.descripcion :  i18n.global.t('temperatura');
    umeMedicion = resultado ? resultado.unMedida :   i18n.global.t('grados_celsius');
    tituloY = tipoMedicion + ' ' + umeMedicion;
    this.chartOptions.yAxis[1].title.text = tituloY;


    resultado = setpoints.find(item => item.idPar === 6);
    tipoMedicion = i18n.global.t('oxigeno_saturado') 
    umeMedicion = resultado ? resultado.unMedida : null;
    tituloY = tipoMedicion + ' ' + umeMedicion;
    this.chartOptions.yAxis[2].title.text =  tituloY;

    this.idJaula = this.objJaula.id,
    this.getdataendpoint();
    this.getSensores();
    this.getSetPoints();
    this.getDefaultSetPoints();
    this.polldata();

    // ThresholdProcessor output data
    this.ptsa=getParameterThresholdSetArray(setpoints); // Parameter Threshold Set Array
    console.log('Threshold Processor Search Report:', debugThresholdSearch(setpoints));

  },
  beforeUnmount() {
    clearInterval(this.polling);
  },

};

</script>
